
import { convertLocaltoUTCDate } from "../../../services/DateFormatUtility";

export const CER_WCN_LISTING_TABLE_COLUMNS = [

    {
        header: "CER ID",
        enableHiding: false,
        accessorKey: "cvrId",
        maxSize: 80,
        enableSorting: false,
    },
    {
        header: "Modified Date",
        accessorKey: "modifiedDate",
        minSize: 200,
        enableSorting: false,
        Cell: ({ cell }) => {
            const value = cell.getValue();

            if (!value) return "";

            return new Date(value).toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            }).replace(",", "");
        },
    },
    {
        header: "Date of Issuance",
        accessorKey: "dateOfIssuance",
        accessorFn: (row) => {
            if (row.dateOfIssuance) {
                return convertLocaltoUTCDate(row.dateOfIssuance);
            }
        },
        enableColumnFilter: false,
        enableSorting: false,
        enableColumnActions: false,
    },
    {
        header: "Status",
        accessorKey: "status",
        enableSorting: false,
    },

]